"use client"

import React, { useEffect, useRef, useState } from 'react'
import { getFivePostByKeyword, getPostDataByUrl } from '@/app/api/post/postAPI'
import Link from 'next/link';
import TableOfContent from "@/components/common/post/TableOfContent"
import { Skeleton } from 'primereact/skeleton';
import "@/assets/jodit-css/jodit-post.css";
import dynamic from "next/dynamic";
const JoditEditor = dynamic(() => import("jodit-react"), {
    ssr: false,
})

function Post({ url }) {
    const [postTitle, setPostTitle] = useState(null);
    const [postDetail, setPostDetail] = useState(null);
    const [headingList, setHeadingList] = useState(null);
    const [fiveNewestPost, setFiveNewestPost] = useState(null);

    const setDocumentMetadata = (seo, post) => {
        if (!seo && !post) return;
        document.title = seo?.metaTitle || post?.name || 'Con Rùa Biển';

        let descriptionTag = document.querySelector('meta[name="description"]');
        if (!descriptionTag) {
            descriptionTag = document.createElement('meta');
            descriptionTag.setAttribute('name', 'description');
            document.head.appendChild(descriptionTag);
        }
        descriptionTag.setAttribute('content', seo?.metaDescription || post?.description || '');

        let keywordsTag = document.querySelector('meta[name="keywords"]');
        if (!keywordsTag) {
            keywordsTag = document.createElement('meta');
            keywordsTag.setAttribute('name', 'keywords');
            document.head.appendChild(keywordsTag);
        }
        keywordsTag.setAttribute('content', seo?.metaKeywords || ''); 

        let canonicalTag = document.querySelector('link[rel="canonical"]');
        if (!canonicalTag) {
            canonicalTag = document.createElement('link');
            canonicalTag.setAttribute('rel', 'canonical');
            document.head.appendChild(canonicalTag);
        }
        canonicalTag.setAttribute('href', seo?.canonicalUrl || window.location.href); 

        let ogTitleTag = document.querySelector('meta[property="og:title"]');
        if (!ogTitleTag) {
            ogTitleTag = document.createElement('meta');
            ogTitleTag.setAttribute('property', 'og:title');
            document.head.appendChild(ogTitleTag);
        }
        ogTitleTag.setAttribute('content', seo?.ogTitle || seo?.metaTitle || post?.name);

        let ogImageTag = document.querySelector('meta[property="og:image"]');
        if (!ogImageTag) {
            ogImageTag = document.createElement('meta');
            ogImageTag.setAttribute('property', 'og:image');
            document.head.appendChild(ogImageTag);
        }
        ogImageTag.setAttribute('content', seo?.ogImage || post?.titleImage); 

        let ogDescTag = document.querySelector('meta[property="og:description"]');
        if (!ogDescTag) {
            ogDescTag = document.createElement('meta');
            ogDescTag.setAttribute('property', 'og:description');
            document.head.appendChild(ogDescTag);
        }
        ogDescTag.setAttribute('content', seo?.ogDescription || seo?.metaDescription || post?.description);

        let ogUrlTag = document.querySelector('meta[property="og:url"]');
        if (!ogUrlTag) {
            ogUrlTag = document.createElement('meta');
            ogUrlTag.setAttribute('property', 'og:url');
            document.head.appendChild(ogUrlTag);
        }
        ogUrlTag.setAttribute('content', seo?.canonicalUrl || window.location.href);
    };

    const fetchPostData = async (url) => {
        let result = await getPostDataByUrl(url);
        setDocumentMetadata(result?.metaSeo, result?.postDto);
        setPostTitle(result?.postDto.name);
        if (result?.tablePriceList == null) {
            let index = 0;
            let content = result?.postDto.content || ""; 
            let result1 = content.replace(/(<h\d)/g, function (match) {
                let res = match + ` data-header="${index}"`;
                index += 1;
                return res;
            });
            setPostDetail(result1);
        } else {
            let dataPostDetail = addTableToPostDetail(result?.tablePriceList, result?.postDto.content);
            setPostDetail(dataPostDetail);
        }
        let searchKeyword = result?.metaSeo?.metaKeywords;

        if (!searchKeyword || searchKeyword.trim() === "") {
            searchKeyword = result?.postDto?.name;
        }

        if (searchKeyword && searchKeyword.length > 0) {
            fetchFiveNewestPostData(searchKeyword, result?.postDto?.id);
        }
    }
    const headerTop = `<h2 class="ftwp-heading" style="box-sizing: border-box; 
    font-family: utm_helveins; 
    font-weight: normal !important; 
    line-height: 1.4; 
    color: rgb(10, 10, 10); 
    margin-top: 20px; margin-bottom: 10px; 
    font-size: 30px; text-transform: none; letter-spacing: normal; 
    font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; 
    text-align: start; text-indent: 0px; widows: 2; 
    word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255);
     text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;">
    <span style="box-sizing: border-box; color: rgb(0, 0, 0); font-size: 14pt;">
    <strong style="box-sizing: border-box; font-weight: bold;">`;
    const headerEnd = `</strong>
    </span>
    </h2>`;
    const addTableToPostDetail = (dataTable, dataContent) => {
        let result = "";
        if (dataContent === `"<p><br></p>"` || dataContent === null || dataContent === "") {
            dataTable.forEach((table) => {
                let header = headerTop + table?.titleTable + headerEnd;
                let tableContent = header + JSON.parse(table?.contentTable);
                result += tableContent;
            })
            let index = 0;
            result = result.replace(/(<h\d)/g, function (match) {
                let res = match + ` data-header="${index}"`;
                index += 1;
                return res;
            });
        } else {
            let idTables = [];
            for (const table of dataTable) {
                const sting = `banggia=${table?.id}`;
                idTables.push(sting);
            }
            result = insertTablePrices(JSON.parse(dataContent), dataTable, idTables);
        }
        return result;
    }
    const fetchFiveNewestPostData = async (keyword, currentPostId) => {
        let result = await getFivePostByKeyword(keyword);
        if (result?.data?.data) {
            const dataPayload = result.data.data;
            if (dataPayload.postDtos) {
                dataPayload.postDtos = dataPayload.postDtos.filter(p => p.id !== currentPostId);
            }

            if (dataPayload.shippedProjectPostDtos) {
                dataPayload.shippedProjectPostDtos = dataPayload.shippedProjectPostDtos.filter(p => p.id !== currentPostId);
            }
        }
        setFiveNewestPost(result);
    }

    const getHeadingList = async () => {
        setTimeout(() => {
            let list = [];
            let headerList = document.querySelectorAll('[data-header]');
            let id = 0;

            headerList.forEach((dataKey) => {
                const text = dataKey.innerText;
    
                if (dataKey?.nodeName === "H1") {
                    let data = {
                        id: id++,
                        text: text,
                        tag: "H1"
                    };
                    list.push(data);
                } else if (dataKey?.nodeName === "H2") {
                    let data = {
                        id: id++,
                        text: text,
                        tag: "H1"
                    };
                    list.push(data);
                } else {
                    let data = {
                        id: id++,
                        text: text,
                        tag: dataKey?.nodeName
                    };
                    list.push(data);
                }
            });
            
            setHeadingList(list);
        }, 1300);
    }    
    const insertTablePrices = (dataContent, tablePrices, idTables) => {
        for (const id of idTables) {
            const inputString = id;
            const matchResult = inputString.match(/\d+/);
            const extractedNumber = matchResult ? parseInt(matchResult[0]) : null;
            for (const tablePrice of tablePrices) {
                if (tablePrice?.id === extractedNumber) {
                    // const header = `
                    // <div id="ftoc-heading-5" class="ftwp-heading"><span style="font-size: 16px;"><strong>
                    // ${tablePrice?.titleTable}
                    // </strong></span></div><br/>
                    // `;
                    const header = `<h2 class="ftwp-heading" style="box-sizing: border-box; 
                    font-family: utm_helveins; 
                    font-weight: normal !important; 
                    line-height: 1.4; 
                    color: rgb(10, 10, 10); 
                    margin-top: 20px; margin-bottom: 10px; 
                    font-size: 30px; text-transform: none; letter-spacing: normal; 
                    font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; 
                    text-align: start; text-indent: 0px; widows: 2; 
                    word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255);
                     text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;">
                    <span style="box-sizing: border-box; color: rgb(0, 0, 0); font-size: 14pt;">
                    <strong style="box-sizing: border-box; font-weight: bold;">` +
                        tablePrice?.titleTable +
                        `</strong></span></h2>`;
                    dataContent = dataContent.replace(new RegExp(id + "(?=<)", 'g'), header + `<div>` + JSON.parse(tablePrice?.contentTable) + `</div>`)
                }
            }
        }
        let index = 0;
        dataContent = dataContent.replace(/(<h\d)/g, function (match) {
            let res = match + ` data-header="${index}"`;
            index += 1;
            return res;
        });
        return dataContent;
    }
    useEffect(() => {
        if (postTitle === null) {
            fetchPostData(url).then();
            setFiveNewestPost(null);
        }
    }, [url, postTitle])
    useEffect(() => {
        if (headingList === null && postDetail !== null) {
            getHeadingList();
        }
    }, [postDetail]);
    return (
        <>
            {postTitle == null ?
                <div className="container-fluid block-content" style={{ marginTop: 20 }}>
                    <div className="row main-grid">
                        <div className="col-sm-9 posts">
                            <Skeleton className="m-auto mb-4" width="90%" height="300px"></Skeleton>
                            <Skeleton className="m-auto mb-2" width="90%" height="20px"></Skeleton>
                            <Skeleton className="m-auto mb-2" width="90%" height="20px"></Skeleton>
                        </div>
                        <div className="col-sm-3">
                            <Skeleton className="m-auto mb-2" width="90%" height="400px"></Skeleton>
                        </div>
                    </div>
                </div>
                :
                <div className="container-fluid block-content" style={{ marginTop: 20 }}>
                    <div className="row main-grid">
                        <div className="col-sm-9 posts">
                            <div className="single-post">
                                <div className="wow fadeInUp" data-wow-delay="0.3s">
                                    <h1 className="text-center" style={{
                                        fontSize: "xx-large",
                                        fontWeight: "bold",
                                        textShadow: "1px 1px",
                                        marginTop: "-15px",
                                    }}>
                                        {postTitle?.toUpperCase()}
                                    </h1>
                                    {headingList !== null ? <TableOfContent data={headingList} /> : ""}
                                    {postDetail === null ? ""
                                        :
                                        <div
                                            id="editor-post"
                                            style={{ marginBottom: '20%' }}
                                        >
                                            <JoditEditor
                                                value={postDetail}
                                                className="jodit-editor"
                                                config={{
                                                    toolbar: false,
                                                    readonly: true,
                                                    toolbarInline: false,
                                                }}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-3"
                            style={{ position: "sticky", top: 0, marginTop: -53 }}>
                            <div className="sidebar-container">
                                <div className="wow slideInUp" data-wow-delay="0.3s">
                                    <h4 style={{ zoom: "110%", color: "#C8322b" }}>Bài viết liên quan</h4>
                                    <ul className="blog-cats" style={{ marginTop: -30 }}>
                                        {fiveNewestPost ? fiveNewestPost?.data.data.postDtos?.map((data) => (
                                            <li key={data?.id}>
                                                <Link href={data?.urlName} aria-label={data?.name}>
                                                    <h5>{data?.name}</h5>
                                                </Link>
                                            </li>
                                        )) : ""}
                                    </ul>
                                </div>
                                <div className="wow slideInUp" data-wow-delay="0.3s">
                                    <h4 style={{ zoom: "110%", color: "#C8322b" }}>Dự án đã vận chuyển</h4>
                                    <ul className="blog-cats" style={{ marginTop: -30 }}>
                                        {fiveNewestPost ? fiveNewestPost?.data.data.shippedProjectPostDtos?.map((data) => (
                                            <li key={data?.id}>
                                                <Link href={data?.urlName} aria-label={data?.name}>
                                                    <h5>{data?.name}</h5>
                                                </Link>
                                            </li>
                                        )) : ""}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default Post;